import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class UserBadge extends Model {
  constructor() {
    super(...arguments);
    // Attributes
    _defineProperty(this, "grantedBy", Model.attribute('grantedBy'));
    _defineProperty(this, "reason", Model.attribute('reason'));
    _defineProperty(this, "isSeen", Model.attribute('isSeen'));
    _defineProperty(this, "showOnCard", Model.attribute('showOnCard'));
    _defineProperty(this, "isPrimary", Model.attribute('isPrimary'));
    _defineProperty(this, "earnedAt", Model.attribute('earnedAt', Model.transformDate));
    // Relationships
    _defineProperty(this, "user", Model.hasOne('user'));
    _defineProperty(this, "badge", Model.hasOne('badge'));
    _defineProperty(this, "grantedByUser", Model.hasOne('grantedByUser'));
  }
}
flarum.reg.add('fof-badges', 'common/models/UserBadge', UserBadge);